import {gsap} from 'gsap';
import {ScrollTrigger} from "gsap/ScrollTrigger.js";
import {isMobile, isTablet} from "../helpers";

export function parallaxEffect() {
    let $items = $('#parallax_scroll_items .item');
    if (!$items.length) return;
    const isArchive = !!$('#archive_landing').length;
    const isBitrix = !!$('#bitrix_landing').length;
    const isMain = !!($('[data-url="/"]').length);
    const isPortfolio = !!($('[data-url="/portfolio/"]').length);
    isMain ? $items = $('#parallax_scroll_items .col') : '';
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.saveStyles(".mobile, .desktop");

    let percent = {
        plus: 10,
        minus: -10,
    }

    if (!isMobile()) {
        percent.plus = 20;
        percent.minus = -20;
    }

    if (isPortfolio) {
        initPortfolioParallax();

    } else if (isArchive) {
        initArchiveParallax();

    } else if (isMain) {
        initMainPageParallax();

    } else if(isBitrix){
        initBitrixParallax();
    }


    function initPortfolioParallax() {
        for (let i = 0; i < $items.length; i++) {
            const itemTimeLine = gsap.timeline({
                scrollTrigger: {
                    trigger: !isMobile() ? $($items[i]) : $($items[i]).find('.image'),
                    scroller: isMobile() || isTablet() ? '' : '.scroller',
                    // scroller: ".scroller",
                    start: `top-=${percent.minus}% bottom`,
                    end: `bottom+=${percent.plus}% top`,
                    scrub: isMobile() ? 0.8 : true
                    //pin: false,
                    //markers: {startColor: "green", endColor: "red", fontSize: "12px"}
                }
            })
            if ($($items[i]).parents('.our-works-block-inner').hasClass('four-items')) {
                itemTimeLine.from($($items[i]).find('.translated-block'), {
                    yPercent: isMobile() ? -3 : percent.minus,
                    //ease: 'none'
                }).to($($items[i]).find('.translated-block'), {
                    yPercent: isMobile() ? 2 : percent.plus,
                    //ease: 'none'
                })

            } else {
                itemTimeLine.from($($items[i]).find('.translated-block'), {
                    yPercent: isMobile() ? -5 : percent.minus,
                    //ease: 'none'
                }).to($($items[i]).find('.translated-block'), {
                    yPercent: isMobile() ? 5 : percent.plus,
                    //ease: 'none'
                })
            }
        }
    }

    function initArchiveParallax() {
        for (let i = 0; i < $items.length; i++) {
            const itemTimeLine = gsap.timeline({
                scrollTrigger: {
                    trigger: $($items[i]),
                    scroller: isMobile() || isTablet() ? '' : '.scroller',
                    // scroller: ".scroller",
                    start: 'top bottom',
                    end: 'bottom bottom',
                    scrub: isMobile() ? 0.8 : true,
                    //pin: false,
                    //markers: {startColor: "green", endColor: "red", fontSize: "12px"}
                }
            })
            itemTimeLine.from($($items[i]), {
                autoAlpha: 0,
                ease: 'none',
                yPercent: 20,
                duration: 0.1
            }).to($($items[i]), {
                autoAlpha: 1,
                ease: 'none',
                yPercent: 0,
                duration: 0.1
            })
        }
    }

    function initBitrixParallax() {
        for (let i = 0; i < $items.length; i++) {
            const itemTimeLine = gsap.timeline({
                scrollTrigger: {
                    trigger: $($items[i]),
                    scroller: isMobile() || isTablet() ? '' : '.scroller',
                    // scroller: ".scroller",
                    start: 'top bottom',
                    end: isMobile() ? 'bottom bottom' : 'bottom center',
                    scrub: isMobile() ? 0.8 : true,
                    //pin: false,
                    //markers: {startColor: "green", endColor: "red", fontSize: "12px"}
                }
            })
            itemTimeLine.from($($items[i]), {
                autoAlpha: 0,
                ease: 'none',
                yPercent: isMobile() ? 20 : 50,
                duration: 0.1
            }).to($($items[i]), {
                autoAlpha: 1,
                ease: 'none',
                yPercent: 0,
                duration: 0.1
            })
        }
    }

    function initMainPageParallax() {
        for (let i = 0; i < $items.length; i++) {
            const itemTimeLine = gsap.timeline({
                scrollTrigger: {
                    trigger: $($items[i]),
                    scroller: isMobile() || isTablet() ? '' : '.scroller',
                    start: `top-=${percent.minus}% bottom`,
                    end: `bottom+=${percent.plus}% top`,
                    scrub: isMobile() ? 0.8 : true,
                }
            })
            itemTimeLine.from($($items[i]).find('.translated-block'), {
                yPercent: -10,
                //ease: 'none'
            }).to($($items[i]).find('.translated-block'), {
                yPercent: 10,
                //ease: 'none'
            })
        }

    }
}
